import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cn from 'classnames';
import MosCheckbox from '@mos-front-components/public/es/components/MosCheckbox';
import TextArea from '@mos-cat/text-area';

import { updateAppealData } from '../../store/examData/actions';
import { EMOJI_REGEXP } from '../../constants/regexp';

class Row extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isFocused: false
    };
    this.textFieldRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.renderTextField = this.renderTextField.bind(this);
  }

  componentDidUpdate() {
    if (this.props.item.checked && this.state.isFocused) {
      const { current } = this.textFieldRef;
      if (current && current.textInputRef && current.textInputRef.current) {
        current.textInputRef.current.focus();
      }
    }
  }

  handleChange(args) {
    const { updateAppealData } = this.props;

    const updateAppealDataParameters = {
      ...args,
      comment:
        typeof args.comment === 'string'
          ? args.comment.replace(EMOJI_REGEXP, '')
          : this.props.item.comment.replace(EMOJI_REGEXP, ''),
      checked:
        typeof args.checked === 'boolean'
          ? args.checked
          : this.props.item.checked
    };

    if (args.checked) {
      this.setState({ isFocused: true });
      updateAppealData(updateAppealDataParameters);
      return;
    }
    this.setState({ isFocused: false });
    updateAppealData(updateAppealDataParameters);
  }

  renderTextField() {
    const { item } = this.props;

    if (!item.checked) {
      return null;
    }
    return (
      <div className="Table__answers-comment">
        <TextArea
          className="Table__answers-comment-text-field"
          label="Ваш комментарий"
          maxLength={1000}
          onChange={ev =>
            this.handleChange({
              comment: ev.currentTarget.value,
              changedTask: item
            })
          }
          name={`Table__answers-comment-text-field_${item.task_name}`}
          onBlur={() => this.handleChange({ blur: true, changedTask: item })}
          value={item.comment}
          error={item.invalid}
          ref={this.textFieldRef}
        />
      </div>
    );
  }

  render() {
    const { item, span } = this.props;
    const { title } = item;

    const rowClassName = cn('Table__answers-row', {
      'Table__answers-row--red': item.type === 'incorrect',
      'Table__answers-row--orange': item.type === 'partial'
    });

    const cellNumberClassName = cn({
      'Table__answers-cell': true,
      'Table__answers-cell-number': true,
      'Table__answers-cell-number_criteria_number': item.criteria_number,
      'Table__answers-cell-number_span': span
    });

    if (title) {
      return (
        <div className={rowClassName}>
          <div className="Table__answers-row-title">{title}</div>
        </div>
      );
    }

    return (
      <div className={rowClassName}>
        <div className="Table__answers-row-top">
          <div className={cellNumberClassName}>
            <div className="Table__answers-cell-number-inset">
              {item.task_name && (
                <div className="Table__answers-number-group">
                  {item.task_name}
                </div>
              )}

              <MosCheckbox
                checked={item.checked}
                onChange={args =>
                  this.handleChange({
                    checked: args.target.checked,
                    changedTask: item
                  })
                }
              >
                {item.number}
              </MosCheckbox>
            </div>
          </div>
          <div className="Table__answers-cell Table__answers-cell-answer">
            {item.answer === 'Развернутый' ? '' : item.answer}
          </div>
          <div className="Table__answers-cell Table__answers-cell-mark Table__answers-cell--for-desktop">
            {item.mark}
          </div>
          <div className="Table__answers-cell Table__answers-cell-max-mark Table__answers-cell--for-desktop">
            {item.max_mark}
          </div>
          <div className="Table__answers-cell Table__answers-cell-mark-max-mark Table__answers-cell--for-mobile">
            {item.mark} из {item.max_mark}
          </div>
        </div>
        {this.renderTextField()}
      </div>
    );
  }
}

Row.propTypes = {
  span: PropTypes.bool,
  item: PropTypes.shape({
    title: PropTypes.string,
    answer: PropTypes.string,
    number: PropTypes.string,
    mark: PropTypes.number,
    max_mark: PropTypes.number,
    checked: PropTypes.bool
  }).isRequired,
  updateAppealData: PropTypes.func.isRequired
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, dispatch =>
  bindActionCreators(
    {
      updateAppealData
    },
    dispatch
  )
)(Row);
